import { z } from 'zod';
export const AobDetailsSchema = z.record(z.string(), z.unknown());
